var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDollarCoinIcon = function SvgDollarCoinIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FEC807"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FEC807"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.13698 9.13632 9.07132-4.07199 13.314.170654.105657 13.379-4.13698 9.13632Z",
    fill: "#FFDA56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00011 20.0001 20.0001 4.00011l3.5355 3.53553L7.53565 23.5356l-3.53554-3.5355Z",
    fill: "#FFDA56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.5c2.4853 0 4.5-2.0147 4.5-4.5 0-2.48528-2.0147-4.5-4.5-4.5-2.48528 0-4.5 2.01472-4.5 4.5 0 2.4853 2.01472 4.5 4.5 4.5Zm0 2.5c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7-3.86599 0-7 3.13401-7 7 0 3.866 3.13401 7 7 7Z",
    fill: "#EEB13D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7-3.86599 0-7 3.13401-7 7 0 3.866 3.13401 7 7 7Z",
    fill: "#EEB13D"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.168 17v-1.6304c-1.05136-.0513-2.07129-.3605-2.668-.7371l.471-2.0074c.65956.3945 1.58563.755 2.60514.755.89466 0 1.50646-.3784 1.50646-1.0642 0-.6519-.5016-1.0637-1.66359-1.492-1.67908-.618-2.82473-1.47555-2.82473-3.14074 0-1.50944.97342-2.69363 2.65208-3.05324V3h1.53824v1.5099c1.0514.05176 1.7575.29135 2.2754.56667l-.4546 1.93776c-.4082-.18828-1.1302-.5827-2.2599-.5827-1.02036 0-1.34972.48055-1.34972.96018 0 .56667.54936.92673 1.88312 1.476C12.7462 9.5884 13.5 10.5316 13.5 12.0763c0 1.5264-.9889 2.8311-2.7937 3.1738V17H9.168Z",
    fill: "#FEC807"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16807 15.3696V17h1.53833v-1.7499c1.8047-.3427 2.7937-1.6474 2.7937-3.1737 0-.5011-.0793-.9388-.2502-1.3262l-4.57656 4.5765c.16309.0203.32852.0348.49473.0429Z",
    fill: "#FFD646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 3,
    y: 3,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.8,
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.883333 0 0 0 0 0.578751 0 0 0 0 0.298125 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_212_18021"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDollarCoinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dollar-coin-icon.623b5b7b0d61ca4e639f0f3ee6b7b256.svg";